import useCurrentPath from 'hooks/useCurrentPath';

const useShopCurrentPath = (depth: number | number[]) => useCurrentPath(depth);

export default useShopCurrentPath;
